export const LANGUAGES = ['en', 'fr', 'nl', 'de'] as const;
export type Language = (typeof LANGUAGES)[number];

export const LOCALES = ['en-GB', 'fr-FR', 'nl-NL', 'de-DE'] as const satisfies Intl.UnicodeBCP47LocaleIdentifier[];
export type Locale = (typeof LOCALES)[number];

export const LANGUAGE_LOCALE_MAP = {
  en: 'en-GB',
  fr: 'fr-FR',
  nl: 'nl-NL',
  de: 'de-DE'
} as const satisfies Record<Language, Locale>;
